import React, { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import { getEmployeeAttendanceForAdmin, getEmployeeAttendanceForAdminTable, getAttendanceOverviewCount, getAttendanceTableDateShift } from "../../../../services/dashboard";
import './AdminDashboard.css';
import DatePicker from "react-datepicker";
import { convertUTCToIST } from "../../../../utils/validations";

const AdminDashboard = () => {
    const [chartData, setChartData] = useState([]);
    //   const [pieData, setPieData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [pieData, setPieData] = useState([
        ["Task", "Employees"],
        ["Present", 0],
        ["Absent", 0],
    ]);
    const [overviewData, setOverviewData] = useState(null);
    const [attendanceListTable, setAttendanceListTable] = useState([]);
    const [attendanceTableTotal,setAttendanceTableTotal]=useState([]);
    const [data, setData] = useState([]);
    const [tableTotals, setTableTotals] = useState({
        totalEmployees: 0,
        totalPresent: 0,
        totalAbsent: 0
    });

    const today = new Date();

    const [selectDate, setSelectDate] = useState(today);
    const fetchAttendanceOverview = async (selectDate) => {
        try {
            const response = await getAttendanceOverviewCount(selectDate);
            console.log("Overview Data:", response);
            setOverviewData(response);

            // Update pie chart with real data
            setPieData([
                ["Task", "Employees"],
                ["Present", response.presentEmployees || 0],
                ["Absent", response.absentEmployees || 0],
            ]);
        } catch (error) {
            console.error("Failed to fetch attendance overview", error);
        }
    };
    const fetchAttendanceListTable = async (selectDate) => {
        try {
            const response = await getAttendanceTableDateShift(selectDate);
            console.log("Overview Data tabler shift:", response);
            setAttendanceTableTotal(response);
            setAttendanceListTable(response.shiftWise);

            // Update pie chart with real data

        } catch (error) {
            console.error("Failed to fetch Data tabler shift", error);
        }
    };

    // const pieData = [
    //     ["Task", "Hours per Day"],
    //     ["Absent", 9],
    //     ["Presnet", 2],

    // ];
    // Column Chart Options
    const columnOptions = {
        title: "Attendance by Designation",
        colors: ["#34A853", "#EA4335", "#4285F4"],
        hAxis: {
            title: "Designation",
            slantedText: true,
            slantedTextAngle: 45,
        },
        vAxis: {
            title: "Employees Count",
            minValue: 0,
        },
        legend: { position: "top" },
        // ✅ Updated Annotations to remove the small lines
        annotations: {
            alwaysOutside: true,
            textStyle: {
                fontSize: 12,
                // color: '#000',
                auraColor: 'none'
            },
            stem: {
                color: 'transparent', // This hides the small line
                length: 0             // This sets the line length to zero
            },
            datum: {
                stem: {
                    color: 'transparent',
                    length: 0
                }
            }
        },
        bar: { groupWidth: "65%" },
    };

    // Pie Chart Options
    const pieOptions = {
        title: "Overall Attendance",
    };
    const fetchAttendanceData = async (selectDate) => {
        try {
            setIsLoading(true);
            const response = await getEmployeeAttendanceForAdmin(selectDate);

            // ✅ Add roles for annotations
            const formattedColumnData = [
                [
                    "Designation",
                    "Present", { role: "annotation" },
                    "Absent", { role: "annotation" },
                    "Total", { role: "annotation" }
                ],
            ];

            let totalPresent = 0;
            let totalAbsent = 0;

            response.forEach((item) => {
                formattedColumnData.push([
                    item.designationShortName,
                    item.present,
                    item.present.toString(), // Annotation for Present
                    item.absent,
                    item.absent.toString(),  // Annotation for Absent
                    item.total,
                    item.total.toString(),   // Annotation for Total
                ]);

                totalPresent += item.present;
                totalAbsent += item.absent;
            });

            setChartData(formattedColumnData);

            // Note: You should also update your pieData state here 
            // using the totalPresent and totalAbsent calculated above.

        } catch (error) {
            console.error("Failed to fetch dashboard data", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchAttendanceData(selectDate);
    }, [selectDate]);

    useEffect(() => {
        fetchAttendanceOverview(selectDate);
    }, [selectDate]);

    useEffect(() => {
        fetchAttendanceListTable(selectDate);
    }, [selectDate]);
    useEffect(() => {
        fetchAttendance();
    }, [selectDate]);

    const fetchAttendance = async () => {
        try {
            const result = await getEmployeeAttendanceForAdminTable(selectDate);
            // Assuming the API returns an object with districts array and totals
            setData(result.districts || []);
            setTableTotals({
                totalEmployees: result.totalEmployees || 0,
                totalPresent: result.totalPresent || 0,
                totalAbsent: result.totalAbsent || 0
            });
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div style={{ padding: "20px" }}>

            <div className="admin-dash-text"><h1>Admin Dashboard</h1></div>

            {/* 🔹 PIE CHART */}
            <div>
                <div className="date-changes">
                    <label>Select Date: </label>
                    <DatePicker
                        selected={selectDate}
                        dateFormat='dd-MM-yyyy'
                        onChange={(date) => setSelectDate(date)}
                        maxDate={today}
                    />
                </div>

                <div className="pi-border">
                    {/* <h4>Pi Chart for Attendance</h4> */}
                    <div className="grid-style">
                        {/* Column 1: Pie Chart */}
                        <div className="Pichart-div">
                            <Chart
                                chartType="PieChart"
                                data={pieData}
                                options={{
                                    ...pieOptions,
                                    chartArea: { width: '90%', height: '80%' }, // Gives chart more room
                                    legend: { position: 'bottom' }
                                }}
                                width={"100%"}
                                height={"500px"}
                            />
                        </div>

                        {/* Column 2: Stats Container */}
                        <div className="right-side-stats">
                            {/* Card 1: Total Employees Overview */}
                            <div className="stat-card total-card">
                                <div className="card-title">Total Employees </div>
                                <div className="card-main-value">
                                    {overviewData?.totalEmployees || 0}
                                </div>
                                {/* <div className="stat-row">
                                    <div>Present: <span className="present-text">{overviewData?.presentEmployees || 0}</span></div>
                                    <div>Absent: <span className="absent-text">{overviewData?.absentEmployees || 0}</span></div>
                                </div> */}
                            </div>

                            {/* Card 2: Current Shift Details */}
                            <div className="stat-card shift-card">
                                <div className="card-title">Current Shift Employees </div>
                                <div className="admin-dash-count-shift-table-head">
                                    <table className="admin-dash-count-shift-table">
                                        <thead className="admin-dash-count-shift-thead">
                                            <tr className="admin-dash-count-shift-tr">
                                                <th>Shifts</th>
                                                <th>Timings</th>
                                                <th>Total Employees</th>
                                                <th>Present</th>
                                                <th>Absent</th>
                                            </tr>
                                        </thead>
                                        {attendanceListTable.map((value, index) => (
                                            <tbody className="admin-dash-count-shift-tbody">
                                                <tr key={value} className="admin-dash-count-shift-td">
                                                    <td>{value.shiftName}</td>
                                                    <td>{convertUTCToIST(value.startTime)} - {convertUTCToIST(value.endTime)}</td>
                                                    <td>{value.totalEmployees}</td>
                                                    <td>{value.active===true?value.presentEmployees:"-"}</td>
                                                    <td>{value.active===true?value.absentEmployees:"-"}</td>

                                                </tr>

                                            </tbody>
                                        ))}

                                    </table>
                                </div>
                                <div className="stat-row">
                                    {/* <div>Rate: <span className="rate-text">{overviewData?.attendancePercentage || 0}%</span></div>
                                    <div>CROs: <span className="cro-text">{overviewData?.totalCRO || 0}</span></div> */}
                                    <div>Present: <span className="present-text">{attendanceTableTotal?.totalPresent || 0}</span></div>
                                    <div>Absent: <span className="absent-text">{attendanceTableTotal?.totalAbsent || 0}</span></div>

                                </div>
                            </div>

                        </div>
                    </div>



                </div>
            </div>

            {/* 🔹 COLUMN CHART */}
            <div className="column-border">
                {/* <h4>Column Chart for Attendance</h4> */}
                <div className="CoulmnChart-div">

                    <Chart
                        chartType="ColumnChart"
                        width="100%"
                        height="550px"
                        data={chartData}
                        options={columnOptions}
                        className="column-chart-style"
                    />

                </div>
            </div>

            <div>
                <h4>District wise Employee Attendance Details</h4>

                <div className="table-container-admin-dash">
                    <table className="employee-table">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>District</th>
                                <th>Total No.of Employees</th>
                                <th>Present Employees</th>
                                <th>Absent Employees</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((res, index) => (
                                <tr key={res.districtId || index}>
                                    <td>{index + 1}</td>
                                    <td>{res.districtName}</td>
                                    <td>{res.totalEmployees}</td>
                                    <td>{res.present}</td>
                                    <td>{res.absent}</td>
                                </tr>
                            ))}
                            {/* Total Row using API-provided totals */}
                            <tr style={{ backgroundColor: '#f2f2f2', fontWeight: 'bold', borderTop: '2px solid #ddd' }}>
                                <td colSpan="2" style={{ textAlign: 'right', fontWeight: 'bold' }}>Total:</td>
                                <td style={{ fontWeight: 'bold', backgroundColor: '#e8f0fe' }}>{tableTotals.totalEmployees}</td>
                                <td style={{ fontWeight: 'bold', backgroundColor: '#e8f5e9' }}>{tableTotals.totalPresent}</td>
                                <td style={{ fontWeight: 'bold', backgroundColor: '#ffebee' }}>{tableTotals.totalAbsent}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default AdminDashboard;